import React from 'react';
import { SearchSuggestionItemLabelTypography, SearchSuggestionsItemAction, SearchSuggestionsItemIcon, SearchSuggestionsItemLabel } from '../SearchSuggestionItem/style';
import { useSearchEmptySuggestionsListClassName } from './utils';
import { SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX } from './constants';
import { SearchEmptySuggestionsListRoot } from './style';
export var SearchEmptySuggestionsList = function SearchEmptySuggestionsList(_ref) {
  var className = _ref.className,
      theme = _ref.theme;
  var classOverride = useSearchEmptySuggestionsListClassName(SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX, className);
  return React.createElement(SearchEmptySuggestionsListRoot, {
    className: classOverride.Root,
    theme: theme
  }, React.createElement(SearchSuggestionsItemIcon, {
    className: classOverride.ItemIcon,
    theme: theme
  }, null), React.createElement(SearchSuggestionsItemLabel, {
    className: classOverride.ItemLabel,
    theme: theme
  }, React.createElement(SearchSuggestionItemLabelTypography, {
    className: classOverride.ItemLabelTypography,
    paragraph: true,
    medium: true,
    theme: theme
  }, "No results found")), React.createElement(SearchSuggestionsItemAction, {
    className: classOverride.ItemAction,
    theme: theme
  }, null));
};